// extracted by mini-css-extract-plugin
export default {"backgroundImage":"BackgroundImage_backgroundImage__P-u0u"};